var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"hasError":_vm.hasError}),_c('transition',{attrs:{"name":"el-zoom-in-top"}},[(_vm.hasError)?_c('div',{staticClass:"attr-input__error"},[_vm._v(_vm._s(this.errorMsg))]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }